import { AxiosRequestConfig, Method, AxiosResponse, AxiosAdapter } from "axios";
import { getAuthToken } from "src/shared/auth/singletonToken";
import qs from 'qs';
import { shippedDashboardEndpointNeedWarehouseId } from "src/shared/environment";
import type { ProductCreateRequest } from 'src/pages/products/products/submitProduct';
import type { CurrencyUpdatePayload } from 'src/core/forms/submit/mappings';
import type { CreateOrUpdateSalesItemRequest } from 'src/pages/products/salesItems/submitSalesItem';
import type { KeyValuePair } from 'src/core/api/useResponse';

export const BASE_URL = (process.env.REACT_APP_BOLD_API_BASE_URL?.charAt("str".length - 1) === '/') ? process.env.REACT_APP_BOLD_API_BASE_URL?.slice(0, -1) : process.env.REACT_APP_BOLD_API_BASE_URL;

export const BASE_MOCK_URL = "/api";

export const MAX_PAGESIZE = 1000;

export const createUrl = (base, path) =>
  `${base}${path}`;

export const createUrlWithSlug = (base: string, path: string, slug: string | number): string =>
  `${base}${path}${slug}`;

export const authorizationHeaderValue = process.env.REACT_APP_BOLD_API_AUTHENTICATION;

export const client_authorizationHeaderValue = process.env.REACT_APP_BOLD_CLIENT_AUTHENTICATION;

export const DEFAULT_LANGUAGE_ID = 2;

export const DEFAULT_PURCHASE_ORDER_PAGE = 1;

export const DEFAULT_PURCHASE_ORDER_TYPE = 1;

export const DEFAULT_SALES_ORDER_PAGE_SIZE = 20;

export const PRODUCTS_URL = BASE_URL + "/products";

export const SALES_ITEMS_URL = BASE_URL + "/sales-items";

export const IMAGES_URL = "/images";

export const SALES_ORDERS_URL = BASE_URL + "/orders";

export const RETURN_ORDERS_URL = BASE_URL + "/returns/return-orders";

export const RETURN_ORDERS_ROWS = "/return-order-rows";

export const PRODUCT_CLASSES = "/classes";

export const PRODUCT_RECENTLY_CREATED = "/recentlycreated";

export const PRODUCT_TYPES = "/product-types";

export const SUBCLASSES = "/subclasses";

export const PRODUCT_LINES_URL = BASE_URL + "/product-lines";

export const PRODUCT_INFO = "/specification/info";

export const SPECIFICATIONS = "/specifications";

export const STATUSES = "/statuses";

export const PROPERTIES = "/properties";

export const ATTRIBUTES_URL = BASE_URL + PRODUCT_TYPES + PROPERTIES;

export const CAMPAIGNS_URL = BASE_URL + "/campaigns";

export const CUSTOMER_URL = BASE_URL + "/customers";

export const PAYMENTS_URL = BASE_URL + "/payments";

export const CREDIT_NOTES_URL = PAYMENTS_URL + "/credit-notes";

export const INVOICES_URL = PAYMENTS_URL + "/invoices";

export const BILLABLE_ORDERS_URL = PAYMENTS_URL + "/billable-orders";

export const ADMIN_URL = BASE_URL + "/admin";

export const CURRENCIES_URL = ADMIN_URL + "/currencies";

export const TAX_RATES_URL = ADMIN_URL + "/tax-rate-specifications";

export const ORDER_ORIGINS_URL = ADMIN_URL + "/order-origins";

export const SALES_SHIPPING_METHODS_URL = ADMIN_URL + "/sales-shipping-methods";

export const WAREHOUSE_SHIPPING_METHODS_URL = ADMIN_URL + "/delivery-methods";

export const PURCHASING_SHIPPING_METHODS_URL = ADMIN_URL + "/procurement-shipping-methods";

export const PURCHASING_SHIPPING_TERMS_URL = ADMIN_URL + "/procurement-shipping-terms";

export const PAGE_SIZE = "pagesize=";

export const SEARCH = "?search=";

export const PRODUCT_TYPE_ID = "productTypeId=";

export const MANUFACTURERS_URL = BASE_URL + "/manufacturers";

export const COUNTRIES_URL = BASE_URL + "/countries";

export const CATEGORIES_URL = BASE_URL + "/categories";

export const CATEGORIES_MODIFY_URL = "/categories";

export const SALESASSORTMENTS = "/sales-assortments";

export const SUPPLIER_PRODUCTS = "/supplier-products";

export const SUPPLIER_PRODUCTS_URL = BASE_URL + SUPPLIER_PRODUCTS;

export const SUPPLIERS_URL = BASE_URL + "/suppliers";

export const PROCUREMENT_URL = BASE_URL + "/procurement";

export const PURCHASE_ORDERS_URL = PROCUREMENT_URL + "/purchase-orders";

export const PURCHASE_ORDER_DRAFTS_URL = PROCUREMENT_URL + "/purchase-order-drafts";

export const PURCHASE_ORDER_DRAFT_URL = PROCUREMENT_URL + "/purchase-order-drafts";

export const BACKORDERS_URL = PROCUREMENT_URL + "/back-orders";

export const PURCHASE_REQUESTS_URL = PROCUREMENT_URL + "/purchase-requests";

export const LANGUAGE_ID = "languageid=";

export const REPORTS = BASE_URL + "/reports";

export const SALES_REPORTS = REPORTS + "/sales";

export const CAMPAIGN_SALES_REPORTS = SALES_REPORTS + "/campaigns";

export const REFERENCE_DATA = "/reference-data";

export const LOW_ORDER_POINTS = BASE_URL + "/low-order-points";

export const WAREHOUSE_URL = BASE_URL + "/warehouses";

export const DISPATCH_URL = WAREHOUSE_URL + "/dispatching";

export const RECEIVING_URL = WAREHOUSE_URL + "/receiving";

export const FULLFILLMENT_URL = BASE_URL + "/fulfillment";

export const TRANSFER_ORDES_URL = WAREHOUSE_URL + "/transfer-orders";

export const DARHBOARD_URL = BASE_URL + "/dashboard";

export const SORT = "&sort=";

export const SORT_DEFAULT = SORT + "-CreateDate";

const DISABLE_SAVE = false;

const noopAdapter: AxiosAdapter = async (config): Promise<AxiosResponse<any>> => {
  return { data: null, status: 204, statusText: "No Content", headers: {}, config: { ...config, headers: (config as any).headers ?? {}, } as any, };
};

export const buildRequestConfig = (UrlParts: (string | number | boolean)[], requestMethod: Method = "GET", data: any = null,): AxiosRequestConfig<any> => {
  const mergedUrl = UrlParts.join("");
  const isUserSettings = mergedUrl.includes("/user-settings");
  if (
    DISABLE_SAVE &&
    requestMethod !== "GET" &&
    !isUserSettings
  ) {
    return { url: mergedUrl, method: requestMethod, data, headers: {}, adapter: noopAdapter, };
  }
  return {
    url: mergedUrl,
    method: requestMethod,
    headers: {
      // 'Authorization': token ? `Bearer ${token}` : authorizationHeaderValue
    },
    data,
  };
};

function logFormData(formData) {
  console.log('FormData entries:');
  for (let entry of formData.entries()) {
    console.log(entry[0] + ': ' + entry[1]);
  }
}

export const buildRequestConfig2 = (UrlParts: (string | number | boolean)[], requestMethod: Method = "GET", files: File[] = [], jsonData: any = null): AxiosRequestConfig<any> => {
  const token = getAuthToken();
  const formData = new FormData();
  files?.forEach(file => { formData.append('file', file); });
  const jsonBlob = new Blob([JSON.stringify([...jsonData])],
    { type: 'application/json' });
  formData.append('jsondata', jsonBlob);
  //formData.append('jsondata', '[{"Index":1,"Model":{"ManufacturerId":4,"IsActive":true,"DisplayName":"Test1","FileName":"test.jpg","ResourceTypeId":1}}]');
  const mergedUrl = UrlParts.join('');
  const request = {
    url: mergedUrl,
    method: requestMethod,
    headers: {
      'Authorization': token ? `Bearer ${token}` : authorizationHeaderValue
    },
    data: formData
  };
  logFormData(formData); // Log FormData entries
  //console.log(request)
  return request;
};

export const buildAuthRequestConfig = (grantType, credentials) => {
  const url = `${BASE_URL}/token`;
  let data;
  //console.log("AuthRequestConfig", grantType, credentials)
  if (grantType === "password") {
    data = qs.stringify({ grant_type: "password", UserName: credentials.username, Password: credentials.password });
  } else if (grantType === "refresh_token") {
    // For token refresh: pass only the refresh token.
    data = qs.stringify({ grant_type: "refresh_token", refresh_token: credentials.refresh_token });
  }
  return { url, method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded", "Authorization": client_authorizationHeaderValue }, data };
};

//#region USER/LOGIN
export const getUserToken = (username, password): AxiosRequestConfig =>
  buildAuthRequestConfig("password", { username, password });

export const getUserTokenWithRefreshToken = (refresh_token): AxiosRequestConfig =>
  buildAuthRequestConfig("refresh_token", { refresh_token });

export const getUserSettings = (): AxiosRequestConfig => {
  return buildRequestConfig([BASE_URL, "/user-settings"]);
};

export const updateUserSettings = (data): AxiosRequestConfig => {
  return buildRequestConfig([BASE_URL, "/user-settings"], "PUT", data);
};

export const getUrl = (url: string): AxiosRequestConfig =>
  (buildRequestConfig([url]));

export const get2FASetup = (): AxiosRequestConfig =>
  buildRequestConfig([BASE_URL, "/user-accounts/2fa/setup"]);

export const confirm2FASetup = (OTPCode: string): AxiosRequestConfig =>
  buildRequestConfig([BASE_URL, "/user-accounts/2fa/confirm?code=", encodeURIComponent(OTPCode.trim())], "POST");

export const invalidate2FA = (): AxiosRequestConfig =>
  buildRequestConfig([BASE_URL, "/user-accounts/2fa/invalidate"], "POST");

//#region PRODUCT
export const getProductReferenceData = (): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, REFERENCE_DATA, "?", LANGUAGE_ID, 2]));

export const getProducts = (productTypeId: number, manufId: number, productLineId: number, discontinued: boolean): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, "?", PRODUCT_TYPE_ID, productTypeId, "&manufId=", manufId, "&productLineId=", productLineId, "&discontinued=", discontinued]));

export const getAllProducts = (pageSize: number, page: number): AxiosRequestConfig =>
(
  buildRequestConfig([PRODUCTS_URL, SEARCH, "&", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT, "&statusFilter=1"]) //No DISCONTINUED items by default
);

export const getDiscontinuedProducts = (pageSize: number, page: number): AxiosRequestConfig =>
(
  buildRequestConfig([PRODUCTS_URL, SEARCH, "&", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT, "&statusFilter=2"]) // DISCONTINUED only 
);

export const getNothing = (): AxiosRequestConfig =>
  (buildRequestConfig([]));

export const getProductById = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, "/", id]));

export const getProductSubClasses = (productClassId: number): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, PRODUCT_CLASSES, "/", productClassId, SUBCLASSES]));

export const getRecentlyCreated = (): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, PRODUCT_RECENTLY_CREATED, "?", PAGE_SIZE, MAX_PAGESIZE]));

export const getProductClasses = (): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, PRODUCT_CLASSES]));

export const getProductTypes = (): AxiosRequestConfig =>
  (buildRequestConfig([BASE_URL, PRODUCT_TYPES, "?", PAGE_SIZE, MAX_PAGESIZE]));

export const getProductStatuses = (): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, STATUSES]));

export const searchProducts = (searchKey: string): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, SEARCH, searchKey]));

export const createProduct = (product: ProductCreateRequest): AxiosRequestConfig<any> =>
  (buildRequestConfig([PRODUCTS_URL], "POST", product));

export const updateProduct = (id: number, product: ProductCreateRequest): AxiosRequestConfig<any> =>
  (buildRequestConfig([PRODUCTS_URL, "/", id], "PATCH", product));

//#endregion
//#region PRODUCT LINES
export const createOrUpdateProductLine = (data: any, method: Method = "POST", id: Number = null): AxiosRequestConfig =>
(
  buildRequestConfig([PRODUCT_LINES_URL, (method === "PATCH" ? `/${id}` : '')], method, data)
);

export const deleteProductLine = (id): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCT_LINES_URL, "?productLineId=", id], "DELETE"));

export const getProductLines = (): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCT_LINES_URL]));

export const getProductLineById = (id): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCT_LINES_URL, "?productLineId=", id]));

//#endregion
//#region Attributes

export const getAttribuesByProductType = (productTypeId: string, languageId: number = DEFAULT_LANGUAGE_ID): AxiosRequestConfig =>
  (buildRequestConfig([BASE_URL, PRODUCT_TYPES, "/", productTypeId, PROPERTIES, "?", LANGUAGE_ID, languageId]));

export const getAttributes = (productTypeId: string, sort?: string, languageId: number = DEFAULT_LANGUAGE_ID): AxiosRequestConfig =>
(
  buildRequestConfig([ATTRIBUTES_URL, `?${PRODUCT_TYPE_ID}=`, productTypeId])
);

export const getAttributesForProducts = (pageSize, page): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, SPECIFICATIONS, "?", PAGE_SIZE, pageSize, "&page=", page]));

export const getUnits = (): AxiosRequestConfig =>
  (buildRequestConfig([ATTRIBUTES_URL, "/units"]));

export const getDataTypes = (): AxiosRequestConfig =>
  (buildRequestConfig([ATTRIBUTES_URL, "/data-types"]));

export const getEnumerationValues = (propertyId: number, languageId: number = DEFAULT_LANGUAGE_ID): AxiosRequestConfig =>
  (buildRequestConfig([ATTRIBUTES_URL, "/", propertyId, "/enumeration",]));

//#endregion

//#region MANUFACTURERS
export const getManufacturers = (): AxiosRequestConfig =>
  (buildRequestConfig([MANUFACTURERS_URL, "?sort=Name&", PAGE_SIZE, MAX_PAGESIZE]));

export const getAllManufacturers = (pageSize, page): AxiosRequestConfig =>
  (buildRequestConfig([MANUFACTURERS_URL, "?", PAGE_SIZE, pageSize, "&page=", page, SORT_DEFAULT]));

export const editManufacturers = (manufacturers, method: Method = 'POST'): AxiosRequestConfig =>
  (buildRequestConfig([MANUFACTURERS_URL], method, manufacturers));

//#endregion

//#region Common
export const getCountries = (): AxiosRequestConfig =>
  (buildRequestConfig([COUNTRIES_URL]));

//#endregion

//#region Categories
export const getCategories = (languageId = DEFAULT_LANGUAGE_ID): AxiosRequestConfig =>
  (buildRequestConfig([CATEGORIES_URL, "?", LANGUAGE_ID, languageId, "&sort=-ParentId&page=1&", PAGE_SIZE, MAX_PAGESIZE]));

export const createCategory = (id, newCategoryData, languageId = DEFAULT_LANGUAGE_ID): AxiosRequestConfig =>
  (buildRequestConfig([CATEGORIES_URL, "/", id, "?", LANGUAGE_ID, languageId], "POST", newCategoryData));

export const createOrUpdateCategories = (categories, method: Method = "POST", languageId = DEFAULT_LANGUAGE_ID): AxiosRequestConfig => {
  return buildRequestConfig([CATEGORIES_URL, "/trees", "?", LANGUAGE_ID, languageId], method, categories);
};

export const deleteCategories = (categories): AxiosRequestConfig => {
  return buildRequestConfig([CATEGORIES_URL,], "DELETE", categories);
};

//#endregion

//#region SUPPLIER PRODUCTS
export const getSuppliers = (): AxiosRequestConfig =>
  (buildRequestConfig([SUPPLIERS_URL, "?", PAGE_SIZE, MAX_PAGESIZE, SORT, "Name"]));

export const getAllSuppliers = (pageSize, page, values?: any): AxiosRequestConfig => {
  const changedSince = values?.changedSince ? encodeURIComponent(String(values.changedSince)) : "";
  const changedPart = changedSince ? `&changedSince=${changedSince}` : "";
  return buildRequestConfig([SUPPLIERS_URL, "?", PAGE_SIZE, pageSize, "&page=", page, SORT_DEFAULT, changedPart]);
};

export const getSupplierById = (id: number): AxiosRequestConfig =>
  (buildRequestConfig([SUPPLIERS_URL, "/", id]));

export const createOrUpdateSupplier = (data: any, method: Method = "POST", id: Number = null): AxiosRequestConfig =>
(
  buildRequestConfig([SUPPLIERS_URL, (method === "PATCH" ? `/${id}` : '')], method, data)
);

export const getSupplierProductBySku = (sku: string): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, SUPPLIER_PRODUCTS, "?sku=", sku]));

export const getSupplierProductById = (id: number): AxiosRequestConfig =>
  (buildRequestConfig([SUPPLIER_PRODUCTS_URL, "/", id]));

export const getAllSupplierProducts = (pageSize: number, page: number): AxiosRequestConfig<SupplierProductCreateUpdateModel> =>
  (buildRequestConfig([SUPPLIER_PRODUCTS_URL, SEARCH, "&sort=ProductName&", "&page=", page, "&", PAGE_SIZE, pageSize, SORT_DEFAULT]));

export const searchSupplierProducts = (search: string, sort: string = "ProductName", page: number = 1, pageSize: number = 50): AxiosRequestConfig<SupplierProductCreateUpdateModel> =>
  (buildRequestConfig([SUPPLIER_PRODUCTS_URL, SEARCH, "&sort=", sort, "&page=", page, "&", PAGE_SIZE, pageSize]));

export const createOrUpdateSupplierProduct = (data: any, method: Method = "POST", id: number = null): AxiosRequestConfig =>
(
  buildRequestConfig([SUPPLIER_PRODUCTS_URL, (method === "PATCH" ? `/${id}` : '')], method, data)
);

export const getSupplierReferenceData = (): AxiosRequestConfig =>
  (buildRequestConfig([SUPPLIERS_URL, REFERENCE_DATA]));

//#endregion
//#region PURCHASE ORDERS
export const getPurchaseOrders = (search: string = "", sort: number = DEFAULT_PURCHASE_ORDER_PAGE, purchaseOrderTypeId: number = DEFAULT_PURCHASE_ORDER_TYPE, page: number = DEFAULT_PURCHASE_ORDER_PAGE, pageSize: number = 100): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDERS_URL, SEARCH, search, "&purchaseOrderTypeId=", purchaseOrderTypeId, "&sort=", sort, "&page=", page, "&", PAGE_SIZE, pageSize, SORT_DEFAULT, "&includeRows=false"]));

export const getPurchaseOrderById = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDERS_URL, "/", id]));

export const getPurchaseOrderReferenceData = (): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDERS_URL, REFERENCE_DATA]));

export const getProductPurchaseHistory = (productId: string): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDERS_URL, "/product-purchase-history?sku=", productId]));

export const getSupplierProductsBySupplierId = (pageSize, page, supplierId: string): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDERS_URL, SUPPLIER_PRODUCTS, "/", supplierId, "?", PAGE_SIZE, pageSize, "&page=", page]));

export const getAllBackorders = (pageSize: number, page: number): AxiosRequestConfig =>
  (buildRequestConfig([BACKORDERS_URL, "?", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]));

export const createOrUpdatePurchaseOrder = (data: any, method: Method = "POST", id: number = null): AxiosRequestConfig =>
(
  buildRequestConfig([PURCHASE_ORDERS_URL, (method === "PATCH" ? `/${id}` : '')], method, data)
);

export const createPurchaseOrderRowsById = (oderId, data): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDERS_URL, "/", oderId, "/purchase-order-rows"], "POST", data));

export const updatePurchaseOrderRowsById = (oderId, data): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDERS_URL, "/", oderId, "/purchase-order-rows"], "PUT", data));

export const deletePurchaseOrderRowById = (oderId, rowId): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDERS_URL, "/", oderId, "/purchase-order-rows/", rowId], "DELETE"));

export const cancelPurchaseOrder = (id: number | string): AxiosRequestConfig =>
  buildRequestConfig([PURCHASE_ORDERS_URL, '/', id], 'DELETE');

export const createPurchaseOrderDraftRow = (id: number | string, data: any): AxiosRequestConfig =>
  buildRequestConfig([PURCHASE_ORDER_DRAFTS_URL, '/', id, '/purchase-order-draft-rows'], 'POST', data);

export const updatePurchaseOrderDraftRows = (id: number | string, data: any[]): AxiosRequestConfig =>
  buildRequestConfig([PURCHASE_ORDER_DRAFTS_URL, '/', id, '/purchase-order-draft-rows'], 'PUT', data);

export const deletePurchaseOrderDraftRow = (id: number | string, rowId: number): AxiosRequestConfig =>
  buildRequestConfig([PURCHASE_ORDER_DRAFTS_URL, '/', id, '/purchase-order-draft-rows/', rowId], 'DELETE');

export const createOrUpdatePurchaseOrderDraft = (data: any, method: Method = "POST", id: number = null): AxiosRequestConfig =>
(
  buildRequestConfig([PURCHASE_ORDER_DRAFT_URL, (method === "PATCH" ? `/${id}` : '')], method, data)
);

export const getLowOrderPoints = (): AxiosRequestConfig => {
  return buildRequestConfig([LOW_ORDER_POINTS, "?nameSearchText="]);
};

export const getLowOrderPointsById = (id): AxiosRequestConfig => {
  return buildRequestConfig([LOW_ORDER_POINTS, "/", id]);
};

export const getLowOrderPointsReferenceData = (): AxiosRequestConfig =>
  (buildRequestConfig([LOW_ORDER_POINTS, REFERENCE_DATA]));

export const createOrUpdateLowOrderPoints = (data: any, method: Method = "POST", id: number = null): AxiosRequestConfig =>
(
  buildRequestConfig([LOW_ORDER_POINTS,
    ((method === "PATCH" || method == "DELETE") ? `/${id}` : ''),
    (method == "DELETE" ? `/low-order-point-rows` : '')
  ], method, data)
);

export const updateLowOrderPointRows = (data: any[], id: number): AxiosRequestConfig =>
(
  buildRequestConfig([LOW_ORDER_POINTS, `/${id}/low-order-point-rows`], "PATCH", data)
);

export const getAllPurchaseOrders = (pageSize: number, page: number, status?): AxiosRequestConfig<SupplierProductCreateUpdateModel> => {
  const request = buildRequestConfig([PURCHASE_ORDERS_URL, SEARCH, "&page=", page, "&", PAGE_SIZE, pageSize, SORT_DEFAULT, "&status=", status ?? ""]);
  return request;
};

export const getPurchaseOrderDraftById = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASE_ORDER_DRAFTS_URL, "/", id]));

export const getAllPurchaseOrderDrafts = (pageSize: number, page: number): AxiosRequestConfig<SupplierProductCreateUpdateModel> =>
  (buildRequestConfig([PURCHASE_ORDER_DRAFTS_URL, SEARCH, "&page=", page, "&", PAGE_SIZE, pageSize, SORT_DEFAULT]));

//#endregion
// src/core/api/apiRequests.ts
//#region DASHBOARD

// src/core/api/apiRequests.ts

//#region DASHBOARD

export const getDashboardSales = (fromDate, toDate): AxiosRequestConfig =>
  (buildRequestConfig([DARHBOARD_URL, "/sales?", "fromDate=", fromDate, "&toDate=", toDate, "&orderChannel=Web&orderChannel=Store&orderChannel=Direct&currencyCode="]));

export const getDashboardReturns = (fromDate): AxiosRequestConfig =>
  (buildRequestConfig([DARHBOARD_URL, "/returns?", "fromDate=", fromDate]));

export const getDashboardShipped = (fromDate, toDate): AxiosRequestConfig =>
  (buildRequestConfig([DARHBOARD_URL, "/warehouses/dispatched?", "fromDate=", fromDate, "&toDate=", toDate, "&orderType=1", ...(shippedDashboardEndpointNeedWarehouseId ? ["&warehouseId=12&warehouseId=20"] : [])]));

export const getDashboardToShip = (fromDate): AxiosRequestConfig =>
  (buildRequestConfig([DARHBOARD_URL, "/warehouses/not-dispatched?", "fromDate=", fromDate, ...(shippedDashboardEndpointNeedWarehouseId ? ["&warehouseId=20&warehouseId=12"] : []), "&orderType=1"]));

// export const getDashboardShipped = ( fromDate, toDate ): AxiosRequestConfig => (
//   buildRequestConfig([DARHBOARD_URL, "/warehouses/dispatched?", "fromDate=", fromDate, "&toDate=",toDate,"&orderType=1&warehouseId=12&warehouseId=20"])
// );

// export const getDashboardToShip = ( fromDate ): AxiosRequestConfig => (
//   buildRequestConfig([DARHBOARD_URL, "/warehouses/not-dispatched?", "fromDate=", fromDate, "&warehouseId=20&warehouseId=12&orderType=1"])
// );

export const getDashboardPurchasing = (fromDate): AxiosRequestConfig =>
  (buildRequestConfig([DARHBOARD_URL, "/procurement/purchase-orders?", "fromDate=", fromDate]));

export const getDashboardCreditNotes = (fromDate): AxiosRequestConfig =>
  (buildRequestConfig([DARHBOARD_URL, "/returns/credit-notes?", "fromDate=", fromDate]));

export const getDashboardSalesMargins = (fromDate, toDate): AxiosRequestConfig =>
  (buildRequestConfig([DARHBOARD_URL, "/sales-margin?", "fromDate=", fromDate, "&toDate=", toDate, "&orderChannel=Web&orderChannel=Store&orderChannel=Direct"]));

//#endregion
//#endregion

//#region WAREHOUSES
export const getWarehouses = (): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "?searchText="]));

export const getFullfillmentOrders = (pageSize: number, page: number): AxiosRequestConfig =>
(
  buildRequestConfig([FULLFILLMENT_URL, "/orders", "?status=41,42,43,44", "&", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT])//44 is the status for "Fulfilled"
);

export const getFullfillmentOrderRows = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([FULLFILLMENT_URL, "/orders/", id, "/rows"]));

export const dispatchFullfillmentOrder = (id: string, commandId: any): AxiosRequestConfig =>
  (buildRequestConfig([FULLFILLMENT_URL, "/orders/", id, "/dispatch-command/", commandId, "/send-to-warehouse"], "POST"));

export const getWarehouseById = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "/", id]));

export const updateWarehouse = (data: { WarehouseName: string }, id: string | number): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "/", id], "PATCH", data));

export const getWarehouseStockById = (pageSize = 1000, page = 1, id = "1001"): AxiosRequestConfig => {
  //console.log("Called getWarehouseStockById", id);
  return buildRequestConfig([FULLFILLMENT_URL, "/fulfillment-quantities?warehouseIds=", id, "&", PAGE_SIZE, pageSize, "&Page=", page]);
};

// Server-default active orders: deliberately no status parameter.
export const getDispatchOrderByWarehouse = (pageSize: number, page: number, id: string | number): AxiosRequestConfig => {
  return buildRequestConfig([DISPATCH_URL, "/", id, "/dispatch-orders?", PAGE_SIZE, pageSize, "&page=", page]);
};

export const getInactiveDispatchOrderByWarehouse = (pageSize: number, page: number, id: string | number): AxiosRequestConfig => {
  return buildRequestConfig([DISPATCH_URL, "/", id, "/dispatch-orders?", PAGE_SIZE, pageSize, "&page=", page, "&status=6,8"]);
};

export const getAllDispatchOrderByWarehouse = (pageSize: number, page: number, id: string | number): AxiosRequestConfig => {
  return buildRequestConfig([DISPATCH_URL, "/", id, "/dispatch-orders?", PAGE_SIZE, pageSize, "&page=", page, "&status=1,3,4,5,6,8,98,99,100,101,102,103"]);
};

export const getDispatchOrderById = (orderId, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/dispatch-orders", "?", "dispatchOrderId=", orderId]));

export const getDispatchOrderByPickingList = (pickingListid, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/picking-list", "/", pickingListid, "/start-packing"], "POST"));

export const cancelDispatchOrderByPickingList = (pickingListid, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/picking-list", "/", pickingListid, "/cancel-packing"], "POST"));

export const getShipmentLabelsBywarehouse = (shipmentId, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/dispatch-order", "/shipments/", shipmentId]));

export const getCollectivePickingList = (pickingListIds: string, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/collective-picking-list", "?", "pickingListIds=", pickingListIds]));

export const getPickingListByDispatchOrder = (orderId, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/dispatch-order", "/", orderId, "/picking-list"]));

export const getDispatchOrderReferenceData = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/dispatch-order", REFERENCE_DATA]));

export const dispatchDispatchOrder = (data: any, method: Method = "POST", pickingListId: Number = null): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", data?.warehouseId, "/picking-list/", pickingListId, "/dispatch"], method, data));

export const dispatchDispatchOrderAddressLabels = (data: any, method: Method = "POST", pickingListId: number | null = null): AxiosRequestConfig => {
  const { warehouseId, WarehouseId, ...body } = data;
  return buildRequestConfig([DISPATCH_URL, "/", warehouseId ?? WarehouseId, "/picking-list/", pickingListId, "/dispatch/address-labels"], method, body);
};

export const dispatchDispatchOrderShipment = (packages: any[], warehouseId: number | string, pickingListId: number | string, shipmentId: number | string, deliveryNote: boolean = false, method: Method = "POST"): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/picking-list/", pickingListId, "/dispatch/shipments/", shipmentId, "?deliveryNote=", String(deliveryNote)], method, packages));

export const createShipmentDispatchOrder = (data: any, orderId, warehouseId): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/dispatch-order/", orderId, "/shipments"], "POST", data));

export const updateShipmentDispatchOrder = (data: any, shipmentId, warehouseId): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/dispatch-order/shipments/", shipmentId], "PUT", data));

export const triggerSyncShipmentDispatchOrder = (shipmentId, warehouseId): AxiosRequestConfig =>
  (buildRequestConfig([DISPATCH_URL, "/", warehouseId, "/dispatch-order/shipments/", shipmentId], "POST"));

export const getProductDispatchRate = (productId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "/dispatch-rate/", productId]));

export const getReceivingOrderByWarehouse = (pageSize: number, page: number, id: string | number): AxiosRequestConfig => {
  return buildRequestConfig([RECEIVING_URL, "/", id, "/receiving-advices?", "sender&", PAGE_SIZE, pageSize, "&page=", page, ""]);
};

export const getReceivingOrderById = (orderId, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([RECEIVING_URL, "/", warehouseId, "/receiving-advices/", orderId]));

export const printRelocationOrder = (warehouseId: any, orderId): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "/", warehouseId, "/relocation-order/", orderId, "/print?fileType=pdf"], "POST"));

export const getDefaultReceivingStation = (warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "/receiving/", warehouseId, "/receiving-station"]));

export const getSearchStorageItem = (searchTerm, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "/", warehouseId, "/stock-adjustments/storage-item/", searchTerm]));

export const getGetStorageItem = (productId, manufacturerProductId, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "/", warehouseId, "/stock-adjustments/storage-item/", productId, "?manufProductId=", manufacturerProductId]));

export const stockCorrection = (warehouseId, payload): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, '/', warehouseId, '/stock-adjustments/storage-items/', payload?.ProductId, '/location/', payload?.LocationId], 'PUT', payload));

export const printProductLabel = (productId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, "/", productId, "/product-label"]));

export const getRelocateProductsByWarehouse = (pageSize: number, page: number, id: string | number): AxiosRequestConfig => {
  return buildRequestConfig([RECEIVING_URL, "/", id, "/received-products?", PAGE_SIZE, pageSize, "&page=", page]);
};

export const getAllProductsLocationsByWarehouse = (pageSize: number, page: number, id: string | number): AxiosRequestConfig => {
  return buildRequestConfig([WAREHOUSE_URL, "/", id, "/storage-items/warehouse-item-locations?", PAGE_SIZE, pageSize, "&page=", page]);
};

export const relocateProductsFromDefault = (data: any, warehouseId: string | number, method: Method = 'POST'): AxiosRequestConfig =>
  (buildRequestConfig([RECEIVING_URL, '/', warehouseId, '/relocate-products'], method, data));

export const relocateProduct = (data: any, warehouseId: string | number, productId, method: Method = 'POST'): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, '/', warehouseId, '/products/', productId, '/relocation'], method, data));

export const relocateProducts = (data: any, warehouseId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, '/', warehouseId, '/relocate-products'], "POST", data));

export const receiveProducts = (payload): AxiosRequestConfig =>
  (buildRequestConfig([RECEIVING_URL, '/', payload?.warehouseId, '/register-product?receivingAdviceId=', payload?.receivingAdviceId, '&productId=', payload?.productId, '&storageItemId=', payload?.storageItemId, '&quantityReceive=', payload?.quantityReceive ?? 1, '&receivingCondition=', payload?.condition, '&deliveryNote=Web&note='], 'POST'));

export const getAllWarehouseStock = (pageSize: number, page: number): AxiosRequestConfig => {
  return buildRequestConfig([WAREHOUSE_URL, "/products/quantities?", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]);
};

export const getWarehouseLocationsById = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, "/", id, "/locations"]));

export const getAllTransferOrders = (pageSize: number, page: number): AxiosRequestConfig =>
  (buildRequestConfig([TRANSFER_ORDES_URL, "?", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]));

export const getTransferOrderById = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([TRANSFER_ORDES_URL, "/", id]));

export const getTransferOrderReferenceData = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([TRANSFER_ORDES_URL, REFERENCE_DATA]));

export const getTransferProducts = (pageSize: number, page: number, warehouseId): AxiosRequestConfig => {
  const request = buildRequestConfig([WAREHOUSE_URL, "/", warehouseId, "/transfer-orders/search-products?", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]);
  return request;
};

export const createOrUpdateTransferOrder = (data: any, method: Method = "POST", id: Number = null): AxiosRequestConfig =>
(
  buildRequestConfig([TRANSFER_ORDES_URL, (method === "PATCH" ? `/${id}` : '')], method, data)
);

export const updateTransferOrderRowsByTransferOrderId = (oderId, data, method: Method = "PUT"): AxiosRequestConfig =>
  (buildRequestConfig([TRANSFER_ORDES_URL, "/", oderId, "/transfer-order-rows"], method, data));

export const deleteTransferOrderRowsByTransferOrderId = (oderId, data): AxiosRequestConfig =>
  (buildRequestConfig([TRANSFER_ORDES_URL, "/", oderId, "/transfer-order-rows"], "DELETE", data));

///api/warehouses/transfer-orders/1269/release
export const releaseTransferOrder = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([TRANSFER_ORDES_URL, "/", id, "/release"], "PUT"));

export const revertTransferOrder = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([TRANSFER_ORDES_URL, "/", id, "/revert"], "PUT"));

//#endregion
//#region SALES ITEMS
export const getSalesItemById = (id: number): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ITEMS_URL, "/", id]));

export const getSalesItemBySku = (sku: string): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ITEMS_URL, "?sku=", sku]));

export const getSalesItemPricesBySku = (sku: string): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ITEMS_URL, "/", sku, "/sales-item-prices"]));

export const getSalesItems = (sc: SalesItemsSearchCreteria): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ITEMS_URL, "?", PRODUCT_TYPE_ID, sc.ProductTypeId, "&manufId=", sc.ManufId, "&productLineId=", sc.ProductLineId, "&discontinued=", sc.Discontinued, "&sort=", sc.Sort, "&page=", sc.Page, "&" + PAGE_SIZE, sc.PageSize]));

export const getSalesItemsByCategory = (si: SalesItemsByCategoryRequest): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ITEMS_URL, "?groupTreeId=", si.GroupTreeId, "&groupTreeNodeId=", si.GroupTreeNodeId, "&discontinued=", si.Discontinued, "&sort=", si.Sort, "&page=", si.Page, "&" + PAGE_SIZE, si.PageSize]));

export const getSalesItemsBySearchParams = (sp: SalesItemExtendedSearchParams): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ITEMS_URL, SEARCH], "GET"));

export const getAllSalesItems = (pageSize: number, page: number): AxiosRequestConfig =>
(
  buildRequestConfig([SALES_ITEMS_URL, SEARCH, "&", PAGE_SIZE, pageSize, "&Page=", page, SORT, "-ModifyDate", "&statusFilter=1"]) //No DISCONTINUED items by default])
);

export const getAllDiscontinuedSalesItems = (pageSize: number, page: number): AxiosRequestConfig =>
(
  buildRequestConfig([SALES_ITEMS_URL, SEARCH, "&", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT, "&statusFilter=2"]) //DISCONTINUED only (adjust if needed)
);

export const createOrUpdateSalesItem = (salesItem: CreateOrUpdateSalesItemRequest, method: Method = "POST", id: number = null): AxiosRequestConfig =>
(
  buildRequestConfig([SALES_ITEMS_URL, (id && method != "POST" ? `/${id}` : '')], method, salesItem)
);

export const getImagesFromSalesItemId = (salesItemId: string) =>
  (buildRequestConfig([SALES_ITEMS_URL, "/", salesItemId, IMAGES_URL, "?", LANGUAGE_ID, DEFAULT_LANGUAGE_ID]));

export const getImagesBySku = (sku: string) =>
(
  buildRequestConfig([PRODUCTS_URL, "/", sku, IMAGES_URL,])// "?", LANGUAGE_ID, DEFAULT_LANGUAGE_ID])
);

export const printPriceLabel = (salesItemId: string | number, priceListId): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ITEMS_URL, "/", salesItemId, "/sales-item-prices/price-tag?", "salesPriceListId=", priceListId]));

export const getProductInfoBySalesItemId = (salesItemId: string) =>
  (buildRequestConfig([SALES_ITEMS_URL, "/", salesItemId, PRODUCT_INFO]));

export const updateProductInfo = (productInfo: any) =>
  (buildRequestConfig([SALES_ITEMS_URL, PRODUCT_INFO], "POST", productInfo));

export const getAllPriceLists = () =>
  (buildRequestConfig([BASE_URL, "/assortments", SALESASSORTMENTS]));

export const getPriceListsBySky = (sku: string) =>
  (buildRequestConfig([SALES_ITEMS_URL, "/", sku, SALESASSORTMENTS]));

export const postPriceListBySku = (sku: string | number, newPriceLists: any) => {
  return buildRequestConfig([SALES_ITEMS_URL, "/", sku, SALESASSORTMENTS], "POST", newPriceLists);
};

export const removePriceListBySku = (sku: string | number, newPriceLists: any) => {
  return buildRequestConfig([SALES_ITEMS_URL, "/", sku, SALESASSORTMENTS], "DELETE", newPriceLists);
};

export const getProductInfoBySku = (sku: string, languageId: number) =>
  (buildRequestConfig([SALES_ITEMS_URL, PRODUCT_INFO, "?sku=", sku, "&", LANGUAGE_ID, languageId ?? DEFAULT_LANGUAGE_ID]));

export const updateSalesItemImage = (files: any, metaData: any, sku: string): AxiosRequestConfig =>
  (buildRequestConfig2([PRODUCTS_URL, "/", sku, IMAGES_URL], "POST", files, metaData));

export const removeImagesBySku = (sku: string, resourceId: string) =>
  (buildRequestConfig([PRODUCTS_URL, "/", sku, IMAGES_URL, "/", resourceId, "/unassign"], "DELETE"));

export const updateImagesBySku = (sku: string, resourceId: string, data: any) =>
  (buildRequestConfig([PRODUCTS_URL, "/", sku, IMAGES_URL, "/", resourceId, ""], "PATCH", data));

//#endregion
export const updateSalesItemCategoriesBySalesItemId = (salesItemId: string, categories: any) =>
  (buildRequestConfig([SALES_ITEMS_URL, "/", salesItemId, CATEGORIES_MODIFY_URL], "POST", categories));

export const removeSalesItemCategoriesBySalesItemId = (salesItemId: string, categories: any) =>
  (buildRequestConfig([SALES_ITEMS_URL, "/", salesItemId, CATEGORIES_MODIFY_URL], "DELETE", categories));

//#region Sales Items Attributes
export const getSalesItemAttributesBySku = (sku: string) =>
  (buildRequestConfig([PRODUCTS_URL, "/", sku, SPECIFICATIONS]));

export const updateSalesItemAttributeValues = (id, attributes: any,): AxiosRequestConfig =>
  (buildRequestConfig([PRODUCTS_URL, "/", id, SPECIFICATIONS], "POST", attributes));

export const getReferenceDataByProductType = (productTypeId: number, languageId = 2) =>
( //TEMP FIX WITH LANGUAGE ID SET TO 2 FOR SWEDISH 
  buildRequestConfig([PRODUCTS_URL, REFERENCE_DATA, "/product-type", "?productTypeId=", productTypeId, "&", LANGUAGE_ID, languageId])
);

//#endregion
//#region SALES
export const getSalesOrders = (search: string = ""): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, SEARCH, search, "&", PAGE_SIZE, DEFAULT_SALES_ORDER_PAGE_SIZE]));

export const getAllSalesOrders = (pageSize: number, page: number): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, SEARCH, "&", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]));

export const getSalesOrdersBySearch = (searchValue): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, SEARCH, searchValue, "&", PAGE_SIZE, 1000,]));

export const getAllSalesItemsPrices = (pageSize: number, page: number, values?: { priceListId?: number | string }): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, "/sales-items?priceList=", values?.priceListId ?? '', "&", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT, "&statusFilter=1"]));

export const getSalesOrdersById = (id: string) =>
  (buildRequestConfig([SALES_ORDERS_URL, "/", id]));

export const getSalesOrderRowsById = (id: string) =>
  (buildRequestConfig([SALES_ORDERS_URL, "/", id, "/sales-order-rows"]));

export const createSalesOrder = (salesOrgId, customerId, data): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, "/", salesOrgId, "/", customerId], "POST", data));

export const updateSalesOrder = (orderId, data): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, "?salesOrderId=", orderId, "&release=false"], "PUT", data));

export const releaseSalesOrder = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, "/", id, "/release"], "PUT"));

export const addSalesOrderRow = (orderId, data): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, "/", orderId, "/sales-order-rows"], "POST", data));

export const updateSalesOrderRow = (orderId, rowId, data): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, "/", orderId, "/sales-order-rows/", rowId], "PUT", data));

export const removeSalesOrderRow = (orderId, data): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, "/", orderId, "/sales-order-rows"], "DELETE", data));

export const getOrderReferenceData = (): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, REFERENCE_DATA]));

export const getAllReturnOrders = (pageSize: number, page: number): AxiosRequestConfig =>
  (buildRequestConfig([RETURN_ORDERS_URL, "?", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]));

export const getReturnOrderById = (id: string) =>
  (buildRequestConfig([RETURN_ORDERS_URL, "/", id]));

export const scrapReturnOrderItems = (data: any, method: Method = "POST", id: number | string = null): AxiosRequestConfig =>
(
  buildRequestConfig([RETURN_ORDERS_URL, `/${id}/scrap-item`], method, data)
);

export const createReplacementOrder = (data: any, method: Method = "POST", id: number | string = null): AxiosRequestConfig =>
(
  buildRequestConfig([RETURN_ORDERS_URL, `/${id}/replacement-order`], method, data)
);

export const returnToCustomer = (data: any, method: Method = "POST", id: number | string = null): AxiosRequestConfig =>
(
  buildRequestConfig([RETURN_ORDERS_URL, `/${id}/return-to-customer`], method, data)
);

export const returnToWarehouse = (data: any, method: Method = "POST", id: number | string = null): AxiosRequestConfig =>
(
  buildRequestConfig([RETURN_ORDERS_URL, `/${id}/return-to-warehouse`], method, data)
);

export const getReturnOrderReferenceData = (): AxiosRequestConfig =>
  (buildRequestConfig([RETURN_ORDERS_URL, REFERENCE_DATA]));

export const createOrUpdateReturnOrder = (data: any, method: Method = "POST", id: number = null): AxiosRequestConfig =>
(
  buildRequestConfig([RETURN_ORDERS_URL, (method === "PUT" ? `/${id}` : '')], method, data)
);

export const createReturnOrderFromOrder = (data: any, method: Method = "POST", id: number = null): AxiosRequestConfig =>
  (buildRequestConfig([SALES_ORDERS_URL, "/", id, "/return-order"], "POST", data));

export const addReturnOrderRow = (data: any, method: Method = "POST", id: number = null): AxiosRequestConfig =>
(
  buildRequestConfig([RETURN_ORDERS_URL, (method === "POST" ? `/${id + RETURN_ORDERS_ROWS}` : '')], method, data)
);

export const getAllCustomers = (pageSize: number, page: number): AxiosRequestConfig =>
  (buildRequestConfig([CUSTOMER_URL, "?", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]));

export const getCustomersBySearch = (searchValue): AxiosRequestConfig =>
(
  buildRequestConfig([CUSTOMER_URL, "?searchText=", searchValue, "&", PAGE_SIZE, 1000, "&Page=", 1,])
  //buildRequestConfig([CUSTOMER_URL, "?searchText=", searchValue,"&", PAGE_SIZE, pageSize, "&Page=", page,])
);

export const getCustomerById = (id: string) =>
  (buildRequestConfig([CUSTOMER_URL, "/", id]));

export const createOrUpdateCustomer = (data: any, accountId?: string | number): AxiosRequestConfig =>
(
  buildRequestConfig([CUSTOMER_URL, accountId ? `/${accountId}` : '/'], accountId ? 'PATCH' : 'POST', data)
);

export const updateCustomerAddress = (data: any, accountId: string | number, addressId: string | number): AxiosRequestConfig =>
  (buildRequestConfig([CUSTOMER_URL, '/', accountId, '/address?addressId=', encodeURIComponent(addressId)], 'PATCH', data));

export const getCustomerReferenceData = (id: string) =>
  (buildRequestConfig([CUSTOMER_URL, REFERENCE_DATA]));

//#endregion

//#region CAMPAIGNS
export const getAllCampaigns = (pageSize: number, page: number): AxiosRequestConfig =>
  (buildRequestConfig([CAMPAIGNS_URL, "?", PAGE_SIZE, pageSize, "&Page=", page, SORT + "-ValidFrom"]));

export const getCampaignById = (id: string) =>
  (buildRequestConfig([CAMPAIGNS_URL, "/", id]));

export const closeCampaign = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([CAMPAIGNS_URL, "/", id, "/close"], "PUT"));

export const publishCampaign = (id: string): AxiosRequestConfig =>
  (buildRequestConfig([CAMPAIGNS_URL, "/", id, "/publish"], "PUT"));

//create campaign
export const createOrUpdateCampaign = (data: any,): AxiosRequestConfig =>
  (buildRequestConfig([CAMPAIGNS_URL], "POST", data));

export const getCampaignReferenceData = () =>
  (buildRequestConfig([CAMPAIGNS_URL, "/reference-data?campaignId="]));

//#endregion

//#region PAYMENTS
export const getAllCreditNotes = (pageSize: number, page: number): AxiosRequestConfig =>
  (buildRequestConfig([CREDIT_NOTES_URL, "?", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]));

export const getAllInvoices = (pageSize: number, page: number): AxiosRequestConfig =>
  (buildRequestConfig([INVOICES_URL, "?", PAGE_SIZE, pageSize, "&Page=", page, SORT_DEFAULT]));

export const getInvoiceById = (id: string) =>
  (buildRequestConfig([INVOICES_URL, "/", id]));

export const getPrintInvoiceById = (id: string | number) =>
  (buildRequestConfig([INVOICES_URL, "/", id, "/print?languageId=2&printCopy=False"]));

export const getBillableOrders = (id: string) =>
  (buildRequestConfig([BILLABLE_ORDERS_URL]));

//#endregion

//#region ADMIN
export const getCurrencies = (): AxiosRequestConfig =>
  (buildRequestConfig([CURRENCIES_URL]));

export const updateCurrency = (data: CurrencyUpdatePayload, id: number): AxiosRequestConfig<CurrencyUpdatePayload> =>
  (buildRequestConfig([CURRENCIES_URL, "/", id], "PUT", data));

export const getOrderOrigins = (): AxiosRequestConfig =>
  (buildRequestConfig([ORDER_ORIGINS_URL]));

export const getTaxRates = (): AxiosRequestConfig =>
  (buildRequestConfig([TAX_RATES_URL]));

export const getSalesShippingMethods = (): AxiosRequestConfig =>
  (buildRequestConfig([SALES_SHIPPING_METHODS_URL]));

export const getWarehouseShippingMethods = (): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_SHIPPING_METHODS_URL]));

export const getPurchasingShippingMethods = (): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASING_SHIPPING_METHODS_URL]));

export const getPurchasingShippingTerms = (): AxiosRequestConfig =>
  (buildRequestConfig([PURCHASING_SHIPPING_TERMS_URL]));

//#region REPORTS
export const getCampaignReportSalesItemsLastMonth = (search: string = ""): AxiosRequestConfig =>
  (buildRequestConfig([CAMPAIGN_SALES_REPORTS, '/startedlastmonth']));

export const getCampaignReportSalesItemsThisMonth = (search: string = ""): AxiosRequestConfig =>
  (buildRequestConfig([CAMPAIGN_SALES_REPORTS, '/startedthismonth']));

export const getWarehouseValuesSummaryToday = (): AxiosRequestConfig =>
  (buildRequestConfig([WAREHOUSE_URL, '/reports/inventory-values?selectedDate=2024-01-26']));

//#endregion

export const nullRequest = (): AxiosRequestConfig =>
  (buildRequestConfig(['']));

enum SalesItemSearchOnStatus {
  AllItems,
  ExcludeDiscontinuedItems,
  DiscontinuedItemsOnly,
}

enum SalesItemStatus {
  Active = 1,
  Inactive = 2,
  Discontinued = 3,
  Restricted = 4,
}

enum SalesItemTypes {
  Standard = 1,
  Structure = 2,
}

enum SalesItemDateFilterEnum {
  Created,
  Modified,
  Valid,
  ValidFrom,
  ValidTo,
}

enum SalesItemInformationTypeEnum {
  All,
  AnyRequired,
  Information,
  InformationTranslations,
  SpecificationValues,
  SpecificationValueTranslations,
  Resources,
  SalesItemLinks,
}

enum SalesItemInfoMissingEnum {
  AllMissing,
  RequiredMissing,
  SomeMissing,
}

interface SupplierProductCreateUpdateModel {
  Id?: number;
  ProductsId?: string;
  ManufacturerId?: number;
  Manufacturer?: KeyValuePair;
  ManufacturerProduct?: string;
  SupplierAssortmentItemId?: number;
  SupplierProduct?: KeyValuePair;
  SupplierName?: string;
  Price?: number;
  TARIC?: number;
  ValidFrom?: Date;
  ValidTo?: Date;
  ETA?: Date;
  UpdatedAt?: Date;
  Quantity?: string;
  Status?: string;
  EAN?: string;
}

interface SalesItemFilters {
  Discontinued: boolean;
  Sort?: string;
  Page: number;
  PageSize: number;
}

export interface SalesItemsSearchCreteria extends SalesItemFilters {
  ProductTypeId?: number;
  ManufId?: number;
  ProductLineId?: number;
}

export interface SalesItemsByCategoryRequest extends SalesItemFilters {
  GroupTreeId: number;
  GroupTreeNodeId: number;
}

interface SortDescriptor {
  ColName: string;
  Asc: boolean;
}

interface SortingPaging {
  RequestRowCount?: boolean;
  PageNo?: number;
  PageSize?: number;
  SortOrders?: SortDescriptor[];
}

interface SearchParamsBase {
  SP?: SortingPaging;
}

interface SalesItemSearchParamsBase extends SearchParamsBase {
  StatusFilter?: SalesItemSearchOnStatus;
}

interface SalesItemSearchParams extends SalesItemSearchParamsBase {
  SalesItemSearchKey?: string;
}

interface SalesItemExtendedSearchParams extends SalesItemSearchParams {
  ManufacturerPartnerId?: number;
  ProductTypeId?: number;
  Status?: SalesItemStatus;
  SalesItemType?: SalesItemTypes;
  DateFilter?: SalesItemDateFilterEnum;
  DateFrom?: Date;
  DateTo?: Date;
  SalesInformationType?: SalesItemInformationTypeEnum;
  SalesInformationMissing?: SalesItemInfoMissingEnum;
  ResourceTypeMissing?: any;
  SalesItemLinkTypeMissing?: any;
  SelectedLanguageId?: number;
  ResourceTagId?: number;
  ThumbnailSize?: ThumbnailSize;
}

interface ThumbnailSize {
  Height?: number;
  Width?: number;
}
